import { useQuery } from '@tanstack/react-query';
import { getSetupGuide } from './api';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';

export const useSetupGuide = () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();

  const setupGuideQuery = useQuery({
    queryKey: ['setupGuide', workspaceId],
    queryFn: async () => getSetupGuide(workspaceId as number),
    enabled: workspaceId !== null,
  });

  return {
    setupGuideQuery,
  };
};
